export default "__VITE_ASSET__jIF0qKR0__"